var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(['visa', 'mastercard', 'sepa_direct'].includes(_vm.method.cardType))?_c('img',{attrs:{"src":`../../assets/payments/${_vm.method.cardType}.svg`,"alt":"Logo metodo di pagamento"}}):_vm._e(),_c('span',{staticClass:"mb-0"},[_vm._v("•••• "+_vm._s(_vm.method.last4))])])
}
var staticRenderFns = []

export { render, staticRenderFns }